import { Component } from "react";

import { Autoplay } from "swiper";
import { Swiper, SwiperSlide } from 'swiper/react';


const title = "Welcome to Penqueens";
const desc = "6,999 unique NFTs designed for the first-ever miniseries on the Metaverse";


let bannerSlider = [
    {
        imgUrl: 'assets/images/banner/01.png',
        imgAlt: 'NFT Item Image',
    },
    {
        imgUrl: 'assets/images/banner/02.png',
        imgAlt: 'NFT Item Image',
    },
    {
        imgUrl: 'assets/images/banner/03.png',
        imgAlt: 'NFT Item Image',
    },
    {
        imgUrl: 'assets/images/banner/04.png',
        imgAlt: 'NFT Item Image',
    },
    {
        imgUrl: 'assets/images/banner/05.png',
        imgAlt: 'NFT Item Image',
    },
]

class Banner extends Component {
    render() { 
        return (
            <section id="home" className="banner">
                <div className="container">
                    <div className="banner__wrapper">
                        <div className="row">
                            <div className="col">
                                <div className="banner__content" data-aos="zoom-in" data-aos-duration="1000">
                                    <h1>{title}</h1>
                                    <p>{desc}</p>
                                </div>
                                <div className="banner__thumb" data-aos="zoom-in-up" data-aos-duration="1000">
                                    <div className="swiper banner__slider">
                                        <Swiper
                                            spaceBetween={20}
                                            slidesPerView={2}
                                            loop={'true'}
                                            autoplay={{
                                                delay: 5000,
                                                disableOnInteraction: false,
                                            }}
                                            modules={[Autoplay]}
                                            breakpoints={{
                                                0: {
                                                    width: 0,
                                                    slidesPerView: 1,
                                                },
                                                768: {
                                                    width: 768,
                                                    slidesPerView: 3,
                                                },
                                                1200: {
                                                    width: 1200,
                                                    slidesPerView: 4.7,
                                                },
                                            }}
                                        >
                                            {bannerSlider.map((val, i) => (
                                                <SwiperSlide key={i}>
                                                    <div className="banner__item">
                                                        <img src={`${val.imgUrl}`} alt={`${val.imgAlt}`} />
                                                    </div>
                                                </SwiperSlide>
                                            ))}
                                        </Swiper>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}
 
export default Banner;